import { call, put, takeEvery } from "redux-saga/effects";
import * as type from '../../types';
import { getAllLeads, getGraphData, updateLeadApi } from "../../api/admin/NewDashboardApi";

// function* fetchAdminAllLeadsSaga() {
//   try {
//     const response = yield call(getAllLeads);
//     yield put({
//       type: type.FETCH_ADMIN_ALL_LEADS_SUCCESS,
//       payload: response.data
//     });
//   } catch (e) {
//     yield put({
//       type: type.FETCH_ADMIN_ALL_LEADS_FAILURE,
//       message: e.message
//     });
//   }
// }
function* fetchAdminAllLeadsSaga(action) {
  try {
    // ✅ Default to page 1 if not passed
    const page = action.payload?.page || 1;
console.log("🟡 SAGA REQUEST PAGE:", page);
    const response = yield call(getAllLeads, page);
     console.log("🟢 FULL API RESPONSE:", response.data);
    console.log("🟢 PAGINATION FROM API:", response.pagination);


    yield put({
      type: type.FETCH_ADMIN_ALL_LEADS_SUCCESS,
      payload: response
    });
  } catch (e) {
    yield put({
      type: type.FETCH_ADMIN_ALL_LEADS_FAILURE,
      message: e.message
    });
  }
}

function* updateLeadSaga(action) {
  try {
    const { id, payload } = action.payload;

    yield call(updateLeadApi, id, payload);

    // ✅ MUST re-fetch populated data
    yield put({ type: type.FETCH_ADMIN_ALL_LEADS });

  } catch (error) {
    yield put({
      type: type.UPDATE_LEAD_FAILURE,
      error: error.message || error,
    });
  }
}

function* fetchGraphSaga() {
  try {console.log("🔥 FETCH_GRAPH saga triggered");
    const response = yield call(getGraphData);
     console.log("🔥 GRAPH API RESPONSE", response.data);
    yield put({
      type: type.FETCH_GRAPH_SUCCESS,
      payload: response.data, // API returns { success, data }
    });
  } catch (error) {
    yield put({
      type: type.FETCH_GRAPH_FAILURE,
      error: error.message || error,
    });
  }
}

export function* watchFetchGraphSaga() {
  yield takeEvery(type.FETCH_GRAPH, fetchGraphSaga);
}

export function* watchFetchAdminAllLeadsSaga() {
  yield takeEvery(
    type.FETCH_ADMIN_ALL_LEADS,
    fetchAdminAllLeadsSaga
  );
}

export function* watchUpdateLeadSaga() {
  yield takeEvery(
    type.UPDATE_LEAD,
    updateLeadSaga
  );
}